
<c-row class="mb-2">
  <c-col>
    <form class="d-flex align-items-center gap-2 mb-3 flex-wrap" (ngSubmit)="applyFilters()">
      <div class="status-dropdown-wrapper" style="min-width:180px">
        <button type="button" class="form-select text-start status-dropdown-toggle" [class.active]="statusDropdownOpen" (click)="statusDropdownOpen = !statusDropdownOpen">
          {{ getStatusFilterLabel() }}
        </button>
        <div class="status-dropdown-panel" [@dropdownAnim]="statusDropdownOpen ? 'open' : 'closed'">
          <label class="status-dropdown-item" [class.selected]="filter.statuses.length === 0">
            <input type="checkbox" [checked]="filter.statuses.length === 0" (change)="clearStatusFilter()">
            <span>All Statuses</span>
          </label>
          <label *ngFor="let s of clientStatusOptions" class="status-dropdown-item" [class.selected]="isStatusSelected(s)">
            <input type="checkbox" [checked]="isStatusSelected(s)" (change)="toggleStatusFilter(s)">
            <span>{{ s }}</span>
          </label>
        </div>
      </div>
      <select class="form-select" style="min-width:180px;max-width:200px" [(ngModel)]="filter.email_delivery_method" name="email_delivery_method" (change)="applyFilters()">
        <option value="">All Delivery Types</option>
        <option value="Individual">Individual</option>
        <option value="Bulk">Bulk</option>
        <option value="Do Not Send">Do Not Send</option>
        <option value="Auto Approved">Auto Approved</option>
      </select>
      <input type="text" class="form-control flex-grow-1" style="min-width:180px;max-width:300px" placeholder="Search by name or code" [(ngModel)]="filter.search" name="search">
      <button type="submit" class="btn btn-primary text-nowrap">
        <c-icon name="cil-search" size="sm"></c-icon> Search
      </button>
      <button type="button" class="btn btn-secondary text-nowrap" (click)="resetFilters()">
        <c-icon name="cil-reload" size="sm"></c-icon> Reset
      </button>
      <button type="button" class="btn btn-primary text-nowrap ms-auto" (click)="openClientForm()">
        <c-icon name="cil-plus" size="sm"></c-icon> Add Client
      </button>
    </form>
  </c-col>
</c-row>

<!-- Send Document Modal -->
<div *ngIf="showDocSendModal" class="emp-doc-modal-backdrop">
  <div class="emp-doc-modal emp-doc-modal-lg">
    <div class="emp-doc-modal-header">
      <div>
        <h5 class="mb-0">Request Document</h5>
        <p class="text-muted mb-0" style="font-size:0.82rem;">Sending to <strong>{{ docSendTarget?.client_name }}</strong></p>
      </div>
      <button class="emp-doc-modal-close" (click)="closeDocSendModal()">&times;</button>
    </div>
    <div class="emp-doc-modal-body">
      <input
        class="form-control mb-3"
        [(ngModel)]="docSendSearch"
        (ngModelChange)="filterDocSendList()"
        placeholder="Search documents..."
      />
      <div class="emp-doc-card-list" *ngIf="docSendFiltered.length > 0">
        <div
          class="card shadow-sm emp-doc-selectable"
          *ngFor="let doc of docSendFiltered"
          [class.emp-doc-selected]="selectedDocId === doc.id"
          (click)="selectedDocId = doc.id"
        >
          <div class="card-header bg-primary text-white py-2 d-flex align-items-center justify-content-between">
            <strong>{{ doc.title }}</strong>
            <svg *ngIf="selectedDocId === doc.id" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <div class="card-body py-2 px-3">
            <span class="text-muted" style="font-size:0.82rem;">{{ doc.department || 'No department' }}</span>
          </div>
        </div>
      </div>
      <div class="text-center text-muted py-4" *ngIf="docSendFiltered.length === 0">
        <p class="mb-0">No client documents found.</p>
      </div>
    </div>
    <div class="emp-doc-modal-footer">
      <span class="text-muted" style="font-size:0.82rem;" *ngIf="selectedDocId">1 document selected</span>
      <button class="btn btn-secondary btn-sm ms-auto" (click)="closeDocSendModal()" [disabled]="isSendingDoc">Cancel</button>
      <button class="btn btn-success btn-sm" (click)="confirmDocSend()" [disabled]="isSendingDoc || !selectedDocId">
        {{ isSendingDoc ? 'Sending...' : 'Send Document' }}
      </button>
    </div>
  </div>
</div>

<!-- Document History Modal -->
<div *ngIf="showDocHistoryModal" class="emp-doc-modal-backdrop">
  <div class="emp-doc-modal emp-doc-modal-lg">
    <div class="emp-doc-modal-header">
      <h5>Document History — {{ docHistoryTarget?.client_name }}</h5>
      <button class="emp-doc-modal-close" (click)="closeDocHistoryModal()">&times;</button>
    </div>
    <div class="emp-doc-modal-body">
      <div class="text-center text-muted py-3" *ngIf="isLoadingClientHistory">Loading history...</div>
      <div class="text-center text-muted py-3" *ngIf="!isLoadingClientHistory && clientAssignments.length === 0">
        No documents have been sent to this client yet.
      </div>
      <table class="table table-sm table-bordered" *ngIf="!isLoadingClientHistory && clientAssignments.length > 0">
        <thead class="table-light">
          <tr>
            <th>Document</th>
            <th>Status</th>
            <th>Sent</th>
            <th>Signed</th>
            <th>Link</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of clientAssignments">
            <td>{{ a.document_title }}</td>
            <td>
              <span class="badge"
                [ngClass]="{
                  'bg-warning text-dark': a.status === 'pending',
                  'bg-success': a.status === 'signed',
                  'bg-secondary': a.status !== 'pending' && a.status !== 'signed'
                }">
                {{ a.status | titlecase }}
              </span>
            </td>
            <td>{{ a.sent_at ? (a.sent_at | date:'MMM d, yyyy') : '—' }}</td>
            <td>{{ a.signed_at ? (a.signed_at | date:'MMM d, yyyy') : '—' }}</td>
            <td>
              <button class="btn btn-outline-secondary btn-sm py-0 px-2" (click)="copySigningLink(a.token)">
                {{ copiedToken === a.token ? 'Copied!' : 'Copy Link' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="emp-doc-modal-footer">
      <button class="btn btn-secondary btn-sm" (click)="closeDocHistoryModal()">Close</button>
    </div>
  </div>
</div>

<c-row class="mb-3">
  <c-col xs="12">
    <div class="d-flex align-items-end justify-content-between w-100">
      <div class="d-flex align-items-center gap-2">
        <div class="me-3">
          <span class="fw-bold">Total:</span>
          <span>{{ totalItems }}</span>
        </div>
        <button type="submit" class="btn btn-primary btn-sm mx-2" [disabled]="loading" (click)="loadClients(activePage)">
          <c-icon name="cil-reload" size="sm"></c-icon> Refresh
          <c-spinner class="text-white" variant="border" label="Loading..." size="sm" *ngIf="loading"></c-spinner>
        </button>
        <select class="form-select form-select-sm w-auto" [(ngModel)]="itemsPerPage" name="itemsPerPage" (change)="onItemsPerPageChange()">
          <option *ngFor="let size of [10, 20, 50, 100]" [value]="size">{{ size }} / page</option>
        </select>
        <div class="d-flex align-items-center gap-1">
          <button class="btn btn-outline-primary btn-sm" [disabled]="activePage === 1" (click)="onPageChange(activePage - 1)">&larr;</button>
          <ng-container *ngFor="let page of getChunkedPagination(); let idx = index">
            <ng-container *ngIf="page === 'ellipsis'">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="onChunkEllipsisClick(idx > 0)">...</button>
            </ng-container>
            <ng-container *ngIf="page !== 'ellipsis'">
              <button type="button" class="btn btn-sm" [ngClass]="{'btn-primary': activePage === page, 'btn-outline-primary': activePage !== page}" (click)="onPageChange(page)">{{ page }}</button>
            </ng-container>
          </ng-container>
          <button class="btn btn-outline-primary btn-sm" [disabled]="activePage === totalPages" (click)="onPageChange(activePage + 1)">&rarr;</button>
        </div>
      </div>
    </div>
  </c-col>
</c-row>

<c-row>
  <c-col xs>
    <c-card class="mb-4">
      <c-card-body class="c-body">
        <!-- Spinner shown while loading -->
        <div class="d-flex justify-content-center my-4" *ngIf="loading">
          <c-spinner class="text-black" variant="border" label="Loading..."></c-spinner>
        </div>

        <!-- Table shown when data is loaded and not empty -->
        <table cTable class="table table-hover w-100 align-middle" *ngIf="!loading && clients && clients.length > 0; else noData">
          <thead class="table-primary table-header-full">
            <tr>
              <th class="align-middle sortable" (click)="sortBy('client_code')" style="cursor:pointer;white-space:nowrap">
                Client Code
                <span *ngIf="filter.sort_by === 'client_code'">{{ filter.sort_direction === 'asc' ? '▲' : '▼' }}</span>
              </th>
              <th class="align-middle sortable" (click)="sortBy('status')" style="cursor:pointer;white-space:nowrap">
                Status
                <span *ngIf="filter.sort_by === 'status'">{{ filter.sort_direction === 'asc' ? '▲' : '▼' }}</span>
              </th>
              <th class="align-middle sortable" (click)="sortBy('client_name')" style="cursor:pointer;white-space:nowrap">
                Client Name
                <span *ngIf="filter.sort_by === 'client_name'">{{ filter.sort_direction === 'asc' ? '▲' : '▼' }}</span>
              </th>
              <th class="align-middle" style="white-space:nowrap">Active Employees</th>
              <th class="align-middle sortable" (click)="sortBy('contact_email_primary')" style="cursor:pointer;white-space:nowrap">
                Primary Email
                <span *ngIf="filter.sort_by === 'contact_email_primary'">{{ filter.sort_direction === 'asc' ? '▲' : '▼' }}</span>
              </th>
              <th class="align-middle sortable" (click)="sortBy('email_delivery_method')" style="cursor:pointer;white-space:nowrap">
                Email Delivery
                <span *ngIf="filter.sort_by === 'email_delivery_method'">{{ filter.sort_direction === 'asc' ? '▲' : '▼' }}</span>
              </th>
              <th class="align-middle">Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let client of clients; let i = index">
              <tr class="align-middle">
                <td>{{ client.client_code }}</td>
                <td>
                  <span class="badge" [ngClass]="{
                    'bg-success': client.status === 'Great',
                    'bg-warning text-dark': client.status === 'Watch',
                    'bg-info text-dark': client.status === 'Newly Onboard',
                    'bg-secondary': client.status === 'Disengaged' || !client.status,
                    'bg-danger': client.status === 'At Risk'
                  }">
                    {{ client.status || 'N/A' }}
                  </span>
                </td>
                <td>{{ client.client_name }}</td>
                <td class="text-center">{{ getHiredCount(client) }}</td>
                <td>{{ client.contact_email_primary || '-' }}</td>
                <td>{{ client.email_delivery_method || '-' }}</td>
                <td class="d-flex gap-1 align-items-center flex-nowrap">
                  <button class="btn btn-sm btn-outline-primary" (click)="toggleRow(i)" [title]="expandedIndex === i ? 'Collapse' : 'Expand'">
                    {{ expandedIndex === i ? '−' : '+' }}
                  </button>
                  <button class="btn btn-sm btn-outline-secondary" (click)="editClient(client)" title="Edit">
                    <c-icon name="cil-pencil" size="sm"></c-icon>
                  </button>
                  <button class="btn btn-sm btn-outline-primary" (click)="addJobForClient(client)" title="Add Job">
                    <c-icon name="cil-briefcase" size="sm"></c-icon>
                  </button>
                  <button class="btn btn-sm btn-outline-success" (click)="openDocSendModal(client)" title="Send Document">
                    <c-icon name="cil-envelope-letter" size="sm"></c-icon>
                  </button>
                  <button class="btn btn-sm btn-outline-info" (click)="openDocHistoryModal(client)" title="Document History">
                    <c-icon name="cil-history" size="sm"></c-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="expandedIndex === i" class="table-active">
                <td colspan="7" class="p-1">
                  <div class="accordion-details row bg-light-details m-1">
                    <!-- Client Details -->
                    <div class="col-12"><strong class="text-primary">Client Details</strong><hr class="my-1"></div>
                    <div class="col-md-6 mb-2"><strong>Client Code: </strong>{{ client.client_code || '-' }}</div>
                    <div class="col-md-6 mb-2"><strong>Status: </strong>{{ client.status || '-' }}</div>
                    <div class="col-md-6 mb-2"><strong>Direct Supervisor: </strong>{{ client.direct_supervisor_name || '-' }}</div>
                    <div class="col-md-6 mb-2"><strong>Website: </strong>
                      <a *ngIf="client.website" [href]="client.website" target="_blank">{{ client.website }}</a>
                      <span *ngIf="!client.website">-</span>
                    </div>
                    <div class="col-md-6 mb-2"><strong>Contract Start Date: </strong>{{ (client.contract_start_date | date:'MM/dd/yyyy') || '-' }}</div>
                    <div class="col-md-6 mb-2"><strong>End of Contract Date: </strong>{{ (client.end_of_contract_date | date:'MM/dd/yyyy') || '-' }}</div>
                    <div class="col-md-6 mb-2"><strong>Created At: </strong>{{ (client.created_at | date:'MM/dd/yyyy h:mm a') || '-' }}</div>

                    <!-- Primary Contact -->
                    <div class="col-12 mt-2"><strong class="text-primary">Primary Contact</strong><hr class="my-1"></div>
                    <div class="col-md-6 mb-2"><strong>Name: </strong>{{ (client.contact_first_name_primary || '') + (client.contact_last_name_primary ? ' ' + client.contact_last_name_primary : '') || '-' }}</div>
                    <div class="col-md-6 mb-2"><strong>Email: </strong>{{ client.contact_email_primary || '-' }}</div>
                    <div class="col-md-6 mb-2"><strong>Phone: </strong>{{ client.phone_primary || '-' }}</div>

                    <!-- Secondary Contact -->
                    <div class="col-12 mt-2"><strong class="text-primary">Secondary Contact</strong><hr class="my-1"></div>
                    <div class="col-md-6 mb-2"><strong>Name: </strong>{{ (client.contact_first_name_secondary || '') + (client.contact_last_name_secondary ? ' ' + client.contact_last_name_secondary : '') || '-' }}</div>
                    <div class="col-md-6 mb-2"><strong>Email: </strong>{{ client.contact_email_secondary || '-' }}</div>
                    <div class="col-md-6 mb-2"><strong>Phone: </strong>{{ client.phone_secondary || '-' }}</div>

                    <!-- Timesheet -->
                    <div class="col-12 mt-2"><strong class="text-primary">Timesheet</strong><hr class="my-1"></div>
                    <div class="col-md-6 mb-2"><strong>Email Delivery Method: </strong>{{ client.email_delivery_method || '-' }}</div>
                    <div class="col-md-6 mb-2" *ngIf="client.email_delivery_method === 'Bulk'"><strong>Timesheet Link: </strong>
                      <a *ngIf="client.timesheet_link" [href]="client.timesheet_link" target="_blank">{{ client.timesheet_link }}</a>
                      <span *ngIf="!client.timesheet_link">-</span>
                    </div>
                    <div class="col-md-6 mb-2"><strong>Timesheet Last Sent: </strong>{{ (client.timesheet_last_sent | date:'MM/dd/yyyy') || '-' }}</div>

                    <!-- Approvers Section -->
                    <div class="col-12 mt-2">
                      <strong class="text-primary">Timesheet Approvers</strong>
                      <hr class="my-1">
                      <div *ngIf="client.approversLoading" class="d-flex align-items-center gap-2 text-muted small">
                        <c-spinner variant="border" size="sm"></c-spinner> Loading approvers...
                      </div>
                      <ng-container *ngIf="!client.approversLoading">
                        <table class="table table-sm table-bordered mb-0" *ngIf="client.approvers && client.approvers.length > 0">
                          <thead class="table-light">
                            <tr>
                              <th>First Name</th>
                              <th>Last Name</th>
                              <th>Title</th>
                              <th>Email</th>
                              <th>Status</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let approver of client.approvers">
                              <td>{{ approver.first_name }}</td>
                              <td>{{ approver.last_name }}</td>
                              <td>{{ approver.title || '-' }}</td>
                              <td>{{ approver.email }}</td>
                              <td>
                                <span class="badge" [ngClass]="{'bg-success': approver.status === 'active', 'bg-secondary': approver.status !== 'active'}">
                                  {{ approver.status | titlecase }}
                                </span>
                              </td>
                              <td>
                                <button class="btn btn-sm btn-outline-primary"
                                        [disabled]="sendingPortalLinkId === approver.id || approver.status !== 'active'"
                                        (click)="sendPortalLink(approver)"
                                        title="Send Portal Link">
                                  <span *ngIf="sendingPortalLinkId === approver.id" class="spinner-border spinner-border-sm"></span>
                                  <c-icon *ngIf="sendingPortalLinkId !== approver.id" name="cil-send" size="sm"></c-icon>
                                  Send Portal Link
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="text-muted small" *ngIf="!client.approvers || client.approvers.length === 0">
                          No approvers
                        </div>
                      </ng-container>
                    </div>

                    <!-- Job List Section -->
                    <div class="col-12 mt-2">
                      <strong class="text-primary">Job List</strong>
                      <hr class="my-1">
                      <div class="mb-2">
                        <span class="fw-bold">Total Jobs:</span> {{ client.joblists?.length || 0 }}
                      </div>
                      <div *ngIf="client.joblists && client.joblists.length > 0">
                        <table class="table table-sm table-bordered">
                          <thead class="table-light">
                            <tr>
                              <th>Job Code</th>
                              <th>Job Title</th>
                              <th>Employment Type</th>
                              <th>Agreed Hours</th>
                              <th>Status</th>
                              <th>Posted Date</th>
                              <th>Employee ID</th>
                              <th>Employee Name</th>
                              <th>Employee Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let job of client.joblists | slice: (client.jobPage || 0) * 5 : ((client.jobPage || 0) * 5) + 5">
                              <td>{{ job.job_code }}</td>
                              <td>{{ job.job_title }}</td>
                              <td>{{ job.employment_type }}</td>
                              <td>{{ job.Agreed_Hours }}</td>
                              <td>{{ job.status }}</td>
                              <td>{{ job.posted_date | date:'MM-dd-yyyy' }}</td>
                              <td>{{ job.employee?.employee_id || job.employee_id || '-' }}</td>
                              <td>{{ job.employee ? (job.employee.first_name + ' ' + job.employee.last_name) : '-' }}</td>
                              <td>{{ job.employee?.email_address || '-' }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- Pagination Controls -->
                        <div *ngIf="client.joblists.length > 5" class="d-flex justify-content-end align-items-center gap-2">
                          <button class="btn btn-sm btn-outline-primary" [disabled]="(client.jobPage || 0) === 0" (click)="client.jobPage = (client.jobPage || 0) - 1">&larr;</button>
                          <span>Page {{ (client.jobPage || 0) + 1 }} of {{ math.ceil(client.joblists.length / 5) }}</span>
                          <button class="btn btn-sm btn-outline-primary" [disabled]="((client.jobPage || 0) + 1) * 5 >= client.joblists.length" (click)="client.jobPage = (client.jobPage || 0) + 1">&rarr;</button>
                        </div>
                      </div>
                      <div *ngIf="!client.joblists || client.joblists.length === 0" class="text-muted">No jobs found.</div>
                    </div>

                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>

        <!-- Empty state message -->
        <ng-template #noData>
          <div class="alert alert-info text-center" *ngIf="!loading">
            No clients found
          </div>
        </ng-template>

      </c-card-body>
    </c-card>
  </c-col>
</c-row>
